import axios from "@/plugins/axios";

let url = "/api/v1/me/exchanges/bulks";

export const bulks = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    undo: {
        postExec(data) {
            return axios.post(`${url}/${data._id}/undo/exec`, data).then((result) => result.data);
        },
    },
    cash: {
        postExec(data) {
            return axios.post(`${url}/${data._id}/cash/exec`, data).then((result) => result.data);
        },
    },
    gift: {
        postSend(data) {
            return axios.post(`${url}/${data._id}/gift/send`, data).then((result) => result.data);
        },
        postRedo(data) {
            return axios.post(`${url}/${data._id}/gift/redo`, data).then((result) => result.data);
        },
        postUndo(data) {
            return axios.post(`${url}/${data._id}/gift/undo`, data).then((result) => result.data);
        },
    },
};

export default bulks;
